import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    noExecutionDetailsTitle: translate({ id: 'rm.contextual.order.noExecution.title' }),
    noExecutionDetailsDescription: translate({ id: 'rm.contextual.order.noExecution.description' }),
  }))

  return api
}
